const eventCategory = "DIY_Login";

export const postInspectionDiyLoginPageView = {
    event: "Login_page_viewed",
    eventCategory,
    eventAction: "Login page viewed"
};

export const postInspectionDiyLoginGetOtp = {
    event: "Get_OTP_button_clicked",
    eventCategory,
    eventAction: "GET OTP button clicked"
};

export const postInspectionDiyLoginOtpView = {
    event: "OTP_enter_page_viewed",
    eventCategory,
    eventAction: "OTP enter page viewed"
};

export const postInspectionDiyLoginManualOtp = {
    event: "Manually_entered_OTP",
    eventCategory,
    eventAction: "Manually entered OTP"
};

export const postInspectionDiyLoginResendOtp = {
    event: "Resend_OTP_button_clicked ",
    eventCategory,
    eventAction: "Resend OTP button clicked"
};
